import React, { useRef, useState, useEffect } from "react";
import AnvilSignatureModal from '@anvilco/react-signature-modal'
import '@anvilco/react-signature-modal/dist/styles.css'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext/AuthContext.jsx';
import { useFormContext } from "../../utils/FormContext.jsx"
import config from '../../utils/config.js'


const InspectionObjectionWithdrawalSign = ({contract, onInspectionSuccess }) => {

    const [signingURL, setSigningURL] = useState('');
    const [packetEid, setPacketEid] = useState(null); 
    const [packetDetails, setPacketDetails] = useState(null);
    const [documentGroupEid, setDocumentGroupEid] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false); 
    const [eventObject, setEventObject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [manuallyClosed, setManuallyClosed] = React.useState(false);
    const [packetSaved, setPacketSaved] = useState(false); // flag to avoid multiple POSTs
    const { token } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
  // Reset the flag whenever objectionText or contract changes
  setManuallyClosed(false);
}, [contract]);


    useEffect(() => {
        const body = {contract};
          fetch(`${config.apiBaseUrl}/inspection/objection/withdrawal/packet/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
        .then(response => response.json())
        .then(data => {
          setPacketEid(data.data.data.createEtchPacket.eid);
          setDocumentGroupEid(data.data.data.createEtchPacket.documentGroup.eid);
          setPacketDetails(data.data.data.createEtchPacket);
        })
        .catch((error) => {
            console.error('There was an error!', error);
        });
      }, [contract]); 



      useEffect(() => {
        if (packetEid && !isModalOpen && !manuallyClosed && eventObject?.action !== 'signerComplete') {
          const signer = packetDetails?.documentGroup?.signers[0];
      
          fetch(`${config.apiBaseUrl}/inspection/objection/withdrawal/packet/sign`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              userId: signer?.eid,
              signerEid: signer?.eid,
              clientId: signer?.aliasId,
              etchPacketEid: packetEid,
              documentGroupEid: packetDetails?.documentGroup?.eid,
            }),
          })
            .then(response => response.json())
            .then(data => {
              if (data.statusCode === 200) {
                setSigningURL(data.url);
                setIsLoading(false);
                setIsModalOpen(true);
              } else {
                console.error('Error generating sign URL:', data.error);
              }
            })
            .catch(error => {
              console.error('There was an error!', error);
            });
        }
      }, [packetEid, isModalOpen, packetDetails]);

      useEffect(() => {
        if (eventObject?.action === 'signerComplete' && !packetSaved) {
          setPacketSaved(true); // prevent further updates
          // First, fetch the updated packet details from Anvil
          fetch(`${config.apiBaseUrl}/inspection/objection/withdrawal/packet/${packetEid}`)
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
              // Assume data.data.etchPacket contains the updated packet details
              const updatedPacket = data.data.etchPacket;
              setPacketDetails(updatedPacket);
              // Now save it into the main form in MongoDB
              return fetch(`${config.apiBaseUrl}/formdata/${contract._id}/additional-packet`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                  formType: 'Inspection Objection Withdrawal',
                  packetDetails: updatedPacket,
                  packetEid: packetEid,
                }),
              });
            })
            .then(res => res.json())
            .then(data => {
              // Finally, navigate away and show a message.
              onInspectionSuccess(); // Call the callback function
              navigate('/');
              alert('Thank you for signing the Inspection Objection Withdrawal.');
            })
            .catch(err => console.error('Error saving additional packet:', err));
        }
      }, [eventObject, packetEid, contract._id, token, navigate, packetSaved]);
    

  const renderSignModal = () => (
      <AnvilSignatureModal
        iframeURL={signingURL}
        isOpen={isModalOpen}
        onClose={() => {
          
          setIsModalOpen(false)
          setManuallyClosed(true); // mark that the user closed it manually
        }}
        onEvent={(event) => {
          setEventObject(event);
        }}
      />
  );
if (isLoading) {
    return <p></p>;
}
  return (
    <div >
    <h1></h1>
      {renderSignModal()}
    </div>
  );
}

export default InspectionObjectionWithdrawalSign; 